import React, { createContext, useContext, useReducer } from "react";
import { messageReducer } from "../reducers/messageReducer";
import { initialSummary } from "Data/parks";
import { initialDataQuotation, initialErrorsQuotation } from "Data/quotation";

//Create context
export const MessageContext = createContext();

//Initial state
const initialState = {
  messageLoading: true,
  //Tab Control
  activeTab: 'direct-messages',
  //direct chat contect list
  directContact: [],
  dcLoading: true,
  dcPageIndex: 1,
  dcSummary: initialSummary,

  //Quotation contact list
  quotationContact: [],
  qcLoading: true,
  qcPageIndex: 1,
  qcSummary: initialSummary,

  //DC/QC Active User
  activeUser: {},
  //DC/QC Active user Messages
  msg: [],
  msgLoading: true,
  msgPageIndex: 1,
  initialPageIndex: 1,
  newMessageAdded: false,
  oneMessageAdded: false,
  msgSummary: {},
  msgError: '',

  quotationFormToggle: false,
  operatorParksOptions: [],
  //for Quation Form
  formData: initialDataQuotation,
  errors: initialErrorsQuotation,
  //for mobile Screen
  toggleChatContact: false,

};

//Provider
const MessageProvider = ({ children }) => {
  const [messageState, messageDispatch] = useReducer(messageReducer, initialState);


  return (
    <MessageContext.Provider
      value={{
        ...messageState,
        messageDispatch,
      }}
    >
      {children}
    </MessageContext.Provider>
  );
};

//hook
export const useMessageContext = () => useContext(MessageContext);

export default MessageProvider;
